import axios from 'axios';
const host = process.env.REACT_APP_API_HOST; // API 地址

 const submitReview = async (reviewData, token) => {
    try {
        const response = await axios.post(
            `${host}/api/data/chat_data_reviewed`,
            reviewData,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data; // 返回后端响应数据
    } catch (error) {
        console.error('Error submitting review:', error);
        throw error; // 抛出错误以便调用方处理
    }
};
        // 格式化当前时间为 MySQL 支持的格式
        const formatDateForMySQL = (date) => {
            const pad = (n) => (n < 10 ? '0' + n : n);
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        };
export { submitReview, formatDateForMySQL };